import { render, staticRenderFns } from "./AdminStrainTypeAddModal.vue?vue&type=template&id=704a2a0f"
import script from "./AdminStrainTypeAddModal.vue?vue&type=script&lang=js"
export * from "./AdminStrainTypeAddModal.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/home/gl-api/api.greenlists.com/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('704a2a0f')) {
      api.createRecord('704a2a0f', component.options)
    } else {
      api.reload('704a2a0f', component.options)
    }
    module.hot.accept("./AdminStrainTypeAddModal.vue?vue&type=template&id=704a2a0f", function () {
      api.rerender('704a2a0f', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "resources/js/components/AdminStrainTypeAddModal.vue"
export default component.exports